export default __webpack_public_path__ + "static/media/1.57342375.webp";